import React from 'react';
import ReactDOM from 'react-dom';
import 'assets/css/App.css';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import AuthLayout from 'layouts/auth';
import AdminLayout from 'layouts/admin';
import CustomerLayout from 'layouts/customer';
import SupportLayout from 'layouts/support';
import { ChakraProvider } from '@chakra-ui/react';
import theme from 'theme/theme';
import { ThemeEditorProvider } from '@hypertheme-editor/chakra-ui';
import PrivateRoute from "./routes/privateRoute";

ReactDOM.render(
	<ChakraProvider theme={theme}>
		<React.StrictMode>
			
				<HashRouter>
					<Switch>
						<Route path={`/auth`} component={AuthLayout} />
						<PrivateRoute path={`/admin`} component={AdminLayout} requiredRole="Admin" />
						<PrivateRoute path={`/customer`} component={CustomerLayout} requiredRole="Customer" />
						<PrivateRoute path={`/support`} component={SupportLayout} requiredRole="Support" />
						<Redirect from='/' to='/auth' />
					</Switch>
				</HashRouter>
			
		</React.StrictMode>
	</ChakraProvider>,
	document.getElementById('root')
);
